<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#3F033B"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-layout wrap>
      <v-flex xs12 text-left pb-2>
        <span class="mainHeader">STOCK VALUATION</span>
      </v-flex>
      <v-flex xs12 pb-4>
        <v-layout wrap>
          <v-flex xs12 sm4>
            <span class="tablefont">Today's Gold Rate</span><br />
            <span class="mainHeader" style="font-size: 20px">₹{{ goldRate }}/gm</span>
          </v-flex>
          <v-flex xs12 sm4>
            <span class="tablefont">Total Stock Valuation</span><br />
            <span class="mainHeader" style="font-size: 20px">₹{{ totalValuation }}</span>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 py-6 text-left>
        <v-card class="rounded-lg" elevation="0" color="#FFFFFF">
          <v-layout wrap pa-4 v-if="items.length > 0">
            <v-flex xs12>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Item</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Net Weight (gm)</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Count</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Valuation (₹)</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Status</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, i) in items" :key="i" class="table">
                      <td>{{ value.itemName }}</td>
                      <td>{{ value.totalNetWeight }}</td>
                      <td>{{ value.totalCount }}</td>
                      <td>₹{{ value.valuation }}</td>
                      <td>
                        <span v-if="value.isLowStock" style="color: #b00020; font-weight: 600">Low stock (below {{ value.lowStockThreshold }}gm)</span>
                        <span v-else>OK</span>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
          <v-layout wrap pa-4 v-else>
            <v-flex xs12 text-center>No stock found.</v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      items: [],
      goldRate: 0,
      totalValuation: 0,
    };
  },
  mounted() {
    this.getValuation();
  },
  methods: {
    getValuation() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/stock/valuation",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.items = response.data.items;
            this.goldRate = response.data.goldRate;
            this.totalValuation = response.data.totalValuation;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>
